import React from 'react';
import { useTranslation } from 'react-i18next';
import Loader from '../../Components/Loader'
import UserSearchNew from '../Search/UserSearchNew'
import DateTimeInput from '../../Components/DateTimeInput'
import AppointmentComments from './AppointmentComments'
import helpers from '../../Utils/helpers'
import LeadActionHistoryComments from '../Leads/LeadsActionHistoryComments'
import {FormSearchNew} from '../Search/FormSearch'
import customerRoutes from "../../Constants/Customer/customerRoutes";
import { FormInput } from "../FormComponents/Input/Input";
import CustomerSearch from "../Search/CustomerSearch";

function AppointmentForm({  readonly,
                             appointment,
                             isCompleted,
                             onFieldChange,
                             onSaveClick,
                             onSaveAndCreateClick,
                             onCancelClick,
                             onReopenClick,
                             customerSearchOnChange,
                             showReopenButton,
                             assignee,
                             isCreation,
                             hideButtons,
                         }) {
    const { t } = useTranslation();
    const lead = appointment.lead;

    return (
        <form className="skynet-form">
            <div className="appointmentCustomer">
                <FormSearchNew label={t('sendmoviemodal.customer')}>
                    <CustomerSearch onChange={customerSearchOnChange} id={"appointmentSearch"} />
                </FormSearchNew>
                {appointment.customerName && appointment.customerName !== 'N/A' && (
                    <FormInput 
                        label={t("appointmentform.customername")}
                        value={appointment.customerName}
                        readOnly={true}
                    />
                )}
                {appointment.customerNumber && appointment.customerNumber !== 'N/A' && (
                    <FormInput
                        label={t("appointmentform.customernumber")}
                        value={appointment.customerNumber}
                        type="link"
                        link={customerRoutes.customer(appointment.customerNumber)}
                        newTab={true}
                    />
                )}
            </div>
            <FormInput 
                label={t("appointmentform.contactperson")}
                onChange={(value) => onFieldChange('contactPerson', value)}
                value={appointment.contactPerson}
                readOnly={readonly}
            />
            <FormInput 
                label={t("appointmentform.phonenumber")}
                onChange={(value) => onFieldChange('phoneNumber', value)}
                value={appointment.phoneNumber}
                readOnly={readonly}
            />
            <FormInput 
                label={t("appointmentform.emailaddress")}
                onChange={(value) => onFieldChange('emailAddress', value)}
                value={appointment.emailAddress}
                type="email"
                readOnly={readonly}
            />
            <DateTimeInput
                label={t("appointmentform.timeforappointment")}
                onChange={(value) => onFieldChange('time', value)}
                value={appointment.time}
                readonly={readonly}
                closeOnSelect={false}
            />
            <FormSearchNew label={t("appointmentform.assignto")}>
                <UserSearchNew
                    onChange={(user) => onFieldChange('assignee', user.email || '')}
                    defaultSelected={assignee}
                    readonly={readonly}
                />
            </FormSearchNew>
            <FormInput 
                label={t("appointmentform.subject")}
                onChange={(value) => onFieldChange('subject', value)}
                value={appointment.subject}
                readOnly={readonly}
            />
            {appointment.reason && (
                <FormInput 
                    label={t("appointmentform.reason")}
                    value={appointment.reason}
                    disabled={true}
                />
            )}
            <AppointmentComments comments={appointment.allComments} />
            {!isCompleted && (
                <FormInput 
                    label={t("appointmentform.newcomment")}
                    onChange={(value) => onFieldChange('comments', value)}
                    value={appointment.comments || ""}
                    type={"textarea"}
                />
            )}
            <br/>
            {!isCreation && appointment.refData && (
                <FormInput
                    label={t("appointmentform.leadreference")}
                    value={t("appointmentform.leaddetails")}
                    type="link"
                    to={appointment.refData}
                    readOnly={true}
                />
            )}
            {!isCreation && lead && (
                <FormInput 
                    label={t("appointmentform.leadtype")}
                    value={lead.type + ': ' + lead.productNumber}
                    readOnly={true}
                />
            )}
            {!isCreation && lead && (
                <FormInput 
                    label={t("appointmentform.leadsubmitted")}
                    value={helpers.formatDate(lead.dateSubmitted)}
                    readOnly={true}
                />
            )}
            {!isCreation && lead && (
                <LeadActionHistoryComments actionHistory={lead.actionHistory} />
            )}

            <div className="clearfix"></div>
            {!hideButtons && (
                <div className="form-group pt-12 no-left-margin btn-toolbar appointmentActions">
                    <div className="btn-group" role="group" aria-label="button group">
                        <button type="button" className="btn btn-default" onClick={onCancelClick}>
                            {t("appointmentform.cancel")}
                        </button>
                        {showReopenButton && (
                            <button type="button" className="btn" onClick={onReopenClick}>
                                <span className="vismaicon vismaicon-sm vismaicon-refresh"></span>{" "}
                                {t("appointmentform.reopen")}
                            </button>
                        )}
                        {!isCompleted && (<>
                            <button type="button" className="btn" onClick={onSaveClick}>{t("appointmentform.save")}</button>
                            <button type="button" className="btn" onClick={onSaveAndCreateClick}>{t("appointmentform.saveandcreate")}</button>
                        </>)}
                    </div>
                    <Loader />
                </div>
            )}
        </form>
    );
}

export default AppointmentForm;